module.exports = __webpack_public_path__ + "img/holiday-vacation-beach-umbrella.68975abc.svg";